import React, { memo } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

// Compact world topology hosted on CDN.
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// ISO 3166-1 numeric code → EEMA country key
const ISO_TO_KEY = {
  "380": "italy",
  "250": "italy",
  "724": "italy",
  "276": "germany",
  "756": "switzerland",
  "528": "netherlands",
  "056": "belgium", "58": "belgium",
  "442": "luxembourg",
  "233": "baltics", "428": "baltics", "440": "baltics",
  "752": "baltics",
  "826": "uk",
  "620": "portugal",
  "300": "greece",
  "040": "austria", "40": "austria",
  "616": "poland",
  "208": "nordics", "246": "nordics", "578": "nordics", "352": "nordics",
  "203": "czech",
  "348": "hungary",
  "642": "romania",
  "191": "croatia",
};

const ACTIVE_KEYS = new Set(["italy", "germany", "switzerland", "netherlands", "belgium", "luxembourg", "baltics"]);
const FUTURE_KEYS = new Set(["uk", "portugal", "greece", "austria", "poland", "nordics", "czech", "hungary", "romania", "croatia"]);

const styles = {
  active: {
    default: { fill: "#003399", stroke: "#ffffff", strokeWidth: 0.6, outline: "none", cursor: "pointer" },
    hover: { fill: "#1a4dbd", stroke: "#ffffff", strokeWidth: 0.6, outline: "none", cursor: "pointer" },
    pressed: { fill: "#002270", stroke: "#ffffff", strokeWidth: 0.6, outline: "none" },
  },
  future: {
    default: { fill: "#E5E9F2", stroke: "#ffffff", strokeWidth: 0.5, outline: "none", cursor: "pointer" },
    hover: { fill: "#C4CCD9", stroke: "#ffffff", strokeWidth: 0.5, outline: "none", cursor: "pointer" },
    pressed: { fill: "#A9B3C4", stroke: "#ffffff", strokeWidth: 0.5, outline: "none" },
  },
  other: {
    default: { fill: "#F0F2F7", stroke: "#E5E9F2", strokeWidth: 0.4, outline: "none" },
    hover: { fill: "#F0F2F7", stroke: "#E5E9F2", strokeWidth: 0.4, outline: "none" },
    pressed: { fill: "#F0F2F7", stroke: "#E5E9F2", strokeWidth: 0.4, outline: "none" },
  },
};

function EuropeMap({ onCountryEnter, onCountryLeave, onCountryMove }) {
  return (
    <div className="relative w-full">
      <ComposableMap
        projection="geoAzimuthalEqualArea"
        projectionConfig={{ rotate: [-10, -52, 0], scale: 900 }}
        width={800}
        height={640}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const iso = String(geo.id).padStart(3, "0");
              const key = ISO_TO_KEY[iso] || ISO_TO_KEY[String(Number(iso))];
              const kind = ACTIVE_KEYS.has(key) ? "active" : FUTURE_KEYS.has(key) ? "future" : "other";
              const isInteractive = kind !== "other";
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  data-testid={key ? `map-region-${key}` : undefined}
                  onMouseEnter={(e) => isInteractive && onCountryEnter && onCountryEnter(key, e)}
                  onMouseLeave={() => isInteractive && onCountryLeave && onCountryLeave()}
                  onMouseMove={(e) => isInteractive && onCountryMove && onCountryMove(e)}
                  style={styles[kind]}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
    </div>
  );
}

export default memo(EuropeMap);
